module.exports = __webpack_public_path__ + "0383918fb5cc09342018dbe06af47324.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/pricing/close.png
// module id = 442
// module chunks = 0